import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { logError } from '../../services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-auth-callback',
  template: '<ng-casto-loader></ng-casto-loader>',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly customerService: CustomerService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    // Toujours consommée, pour qu'une URL mémorisée ne ressorte pas à une connexion suivante.
    const storedReturnUrl = this.customerService.consumeLoginReturnUrl();
    const returnUrl =
      this.toSafeReturnUrl(this.route.snapshot.queryParamMap.get('returnUrl')) ??
      this.toSafeReturnUrl(storedReturnUrl) ??
      '/';

    try {
      // Aucun jeton HomeByMe n'est demandé ici : le compte HBM n'est créé qu'au premier
      // configurateur ouvert. Se connecter ne coûte donc rien côté HomeByMe.
      await this.customerService.initializeCiamSession();
      await this.router.navigateByUrl(returnUrl);
    } catch (error) {
      logError(error);
      await this.router.navigate(['/'], { queryParams: { ciamError: 'callback' } });
    }
  }

  /**
   * AuthApp réencode `redirectTo` avant d'y renvoyer le client : `returnUrl` arrive alors encodé
   * une fois de trop. On le décode tant qu'il n'a pas la forme d'un chemin,
   * puis on n'accepte qu'un chemin relatif à ce site.
   */
  private toSafeReturnUrl(returnUrl: string | null): string | null {
    let candidate = returnUrl;

    for (let i = 0; candidate && !candidate.startsWith('/') && candidate.includes('%') && i < 3; i++) {
      try {
        candidate = decodeURIComponent(candidate);
      } catch {
        return null;
      }
    }

    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) {
      return null;
    }

    return candidate;
  }
}
